import React from "react";
import { Box } from "@mui/material";
import { progressGradientAnimation } from "../animations";

export const ProgressBar: React.FC<{ progress: number }> = ({ progress }) => (
  <Box
    sx={{
      mt: 1.5,
      height: 6,
      borderRadius: 3,
      backgroundColor: "rgba(38, 41, 59, 0.1)",
      overflow: "hidden",
    }}
  >
    <Box
      sx={{
        height: "100%",
        width: `${progress}%`,
        borderRadius: 3,
        background: (theme) => theme.palette.mode === 'dark' 
          ? "linear-gradient(90deg, #90caf9, #b3e5fc)"
          : "linear-gradient(90deg, #26293B, #4a4e69)",
        backgroundSize: "200% 100%",
        animation: `${progressGradientAnimation} 2s ease infinite`,
        transition: "width 0.3s ease",
      }}
    />
  </Box>
);
